import { render, staticRenderFns } from "./annual-invalid-registered-judge.vue?vue&type=template&id=1ff9ad4d&scoped=true&"
import script from "./annual-invalid-registered-judge.vue?vue&type=script&lang=js&"
export * from "./annual-invalid-registered-judge.vue?vue&type=script&lang=js&"
import style0 from "./annual-invalid-registered-judge.vue?vue&type=style&index=0&id=1ff9ad4d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff9ad4d",
  null
  
)

export default component.exports